import { notification } from 'antd';
import { NotificationPlacement, IconType } from 'antd/es/notification/interface';

interface NotificationConfig {
    type: IconType;
    message: string;
    description?: string;
    duration?: number;
    placement?: NotificationPlacement;
    isDark?: boolean;
}

export const showNotification = ({
                                     type,
                                     message,
                                     description,
                                     duration = 4.5,
                                     placement = 'topRight',
                                     isDark = false,
                                 }: NotificationConfig) => {
    notification.open({
        type,
        duration,
        placement,
        className: isDark ? 'dark-mode-notification' : '',
        style: {
            background: isDark ? '#1f1f1f' : '#ffffff',
        },
        message: (
            <span style={{ color: isDark ? '#ffffff' : '#000000' }}>
    {message}
    </span>
),
    description: description && (
        <span style={{ color: isDark ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.85)' }}>
    {description}
    </span>
),
    onClick: () => {
        notification.destroy();
    },
});
};

// Success notification
export const showSuccessNotification = (message: string, description?: string, isDark?: boolean) => {
    showNotification({ type: 'success', message, description, isDark });
};


// Error notification
export const showErrorNotification = (message: string, description?: string, isDark?: boolean) => {
    showNotification({ type: 'error', message, description, isDark });
};

// Info notification
export const showInfoNotification = (message: string, description?: string, isDark?: boolean) => {
    showNotification({ type: 'info', message, description, isDark });
};

// Warning notification
export const showWarningNotification = (message: string, description?: string, isDark?: boolean) => {
    showNotification({ type: 'warning', message, description, isDark });
};